// src/store/index.js
import { createStore } from 'vuex'
import auth from './modules/auth'
import roles from './modules/roles'
import customerRoles from './modules/customerRoles'
import asterisk from './modules/asterisk'
import phone from './modules/phone'
import presence from './modules/presence'
import communications from './modules/communications'
import contacts from './modules/Contacts'
import users from './modules/users'
import team from './modules/team'
import numbers from './modules/numbers'
import voicemail from './modules/voicemail'
import queues from './modules/queues'
import ivr from './modules/ivr'
import cdr from './modules/cdr'
import wlb from './modules/wlb'
import callGraphProfiles from './modules/callGraphProfiles'
import ringGroups from './modules/ringGroups'
import schedules from './modules/schedules'
import meetings from './modules/meetings'

export default createStore({
  state: {
    isLoading: false,
    initialized: false,
    isAuthenticated: !!localStorage.getItem('token')
  },
  mutations: {
    setLoading(state, payload) {
      state.isLoading = payload
    },
    setInitialized(state, payload) {
      state.initialized = payload
    },
    setAuthenticated(state, payload) {
      state.isAuthenticated = payload
    }
  },
  actions: {
    login({ commit }, token) {
      localStorage.setItem('token', token)
      commit('setAuthenticated', true)
    },
    logout({ commit }) {
      localStorage.removeItem('token')
      commit('setAuthenticated', false)
    }
  },
  modules: {
    auth,
    roles,
    customerRoles,
    asterisk,
    phone,
    presence,
    communications,
    contacts,
    users,
    team,
    numbers,
    voicemail,
    queues,
    ivr,
    cdr,
    wlb,
    callGraphProfiles,
    ringGroups,
    schedules,
    meetings,
  }
})
